import { useEffect, useRef, useState } from "react";
import styles from '../common.module.scss';
import { Divider } from 'primereact/divider';
import { Password } from 'primereact/password';
import { TabPanel, TabView } from 'primereact/tabview';
import { IconEye, IconEyeOff, IconLock, IconMail, IconUser } from "@tabler/icons-react";
import { Spinner } from "react-bootstrap";
import api from "../helpers/crmApis";
import { useNavigate } from "react-router-dom";
import { encodeData } from "./Constant/Constant";

export default function Login() {
    const navigate = useNavigate();
    const passwordRef = useRef(null);
    const [isSignUp, setIsSignUp] = useState(true);
    const [isSignUpLoading, setIsSignUpLoading] = useState(false);
    const [loginData, setLoginData] = useState({
        email: '',
        password: '',
    });
    const [signUpData, setSignUpData] = useState({
        company: '',
        workEmail: '',
        signPassword: '',
        signCnfmPassword: ''
    })
    const [loginDataErrors, setLoginDataErrors] = useState({
        email: { errorMessage: '', showError: false },
        password: { errorMessage: '', showError: false },
        workEmail: { errorMessage: '', showError: false },
        company: { errorMessage: '', showError: false },
        signPassword: { errorMessage: '', showError: false },
        signCnfmPassword: { errorMessage: '', showError: false }
    });

    const [isVisiblePassword, setIsVisiblePassword] = useState(false);
    const [isVisibleCnfrmPassword, setIsVisibleCnfrmPassword] = useState(false);
    const [isVisibleLoginPassword, setIsVisibleLoginPassword] = useState(false);
    const [isLoginLoading, setIsLoginLoading] = useState(false);
    const header = <div className="font-bold mb-3 text-lg">Pick a password</div>;
    const footer = (
        <>
            <hr className="border-gray-300 my-2" />
            <p className="mt-2 font-semibold text-gray-700">Suggestions</p>
            <ul className="pl-4 mt-1 space-y-1 text-sm">
                <li className={loginData.password.match(/[a-z]/) ? "text-green-600" : "text-red-600"}>
                    At least one lowercase
                </li>
                <li className={loginData.password.match(/[A-Z]/) ? "text-green-600" : "text-red-600"}>
                    At least one uppercase
                </li>
                <li className={loginData.password.match(/\d/) ? "text-green-600" : "text-red-600"}>
                    At least one numeric
                </li>
                <li className={loginData.password.match(/[@$!%*?&]/) ? "text-green-600" : "text-red-600"}>
                    At least one special character
                </li>
                <li className={loginData.password.length >= 8 ? "text-green-600" : "text-red-600"}>
                    Minimum 8 characters
                </li>
            </ul>
        </>
    );

    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (email == '') {
            return 'Email is required.'
        } else if (!emailRegex.test(email)) {
            return 'Please enter a valid email.'
        }
        return '';
    }

    const validatePassword = (password) => {
        if (password.length < 8) {
            return "At least 8 characters required.";
        } else if (!/[a-z]/.test(password)) {
            return "At least one lowercase letter required.";
        } else if (!/[A-Z]/.test(password)) {
            return "At least one uppercase letter required.";
        } else if (!/\d/.test(password)) {
            return "At least one numeric digit required.";
        } 
        else if (!/[@$!%*?&]/.test(password)) {
            return "At least one special character required.";
        }
        return "";
    };


    const updateLoginData = (event) => {
        let currentErrors = { ...loginDataErrors };
        const { name, value } = event.target;
        setLoginData({
            ...loginData,
            [name]: value,
        });

        if (name === "email") {
            const emailErrorMessage = validateEmail(value);
            currentErrors[name].showError = emailErrorMessage ? true : false;
            currentErrors[name].errorMessage = emailErrorMessage;
        }

        if (name === "password") {
            const errorMessage = validatePassword(value);
            currentErrors[name].showError = errorMessage ? true : false;
            currentErrors[name].errorMessage = errorMessage;
        }
        setLoginDataErrors(currentErrors);
    }

    const updateSignUpData = (key, value) => {
        setSignUpData({
            ...signUpData,
            [key]: value,
        });
        setLoginDataErrors((prevState) => ({
            ...prevState,
            [key]: { errorMessage: '', showError: false }
        }));
    }

    const handleCreateWorkspace = async() => {
        try {
            let isValid = true;
            let currentErrors = { ...loginDataErrors };
            if (validateEmail(signUpData.workEmail)) {
                currentErrors = { ...currentErrors, workEmail: { errorMessage: validateEmail(signUpData.workEmail), showError: true } };
                isValid = false;
            }
            if (validatePassword(signUpData.signPassword)) {
                currentErrors = { ...currentErrors, signPassword: { errorMessage: validatePassword(signUpData.signPassword), showError: true } };
                isValid = false;
            }
            if (!signUpData?.signCnfmPassword) {
                currentErrors = { ...currentErrors, signCnfmPassword: { errorMessage: 'Confirm password is required', showError: true } };
                isValid = false;
            }
            if (signUpData.signPassword !== signUpData.signCnfmPassword) {
                currentErrors = { ...currentErrors, signCnfmPassword: { errorMessage: 'Password does not match', showError: true } };
                isValid = false;
            }
            setLoginDataErrors(currentErrors);
            if (isValid) {
                setIsSignUpLoading(true);
                let payload = {
                    email: signUpData?.workEmail,
                    password: signUpData?.signPassword,
                }
                const res = await api.post(`/auth/signup`, payload)
                setIsSignUpLoading(false);
                if (res && res?.data?.isExists && res?.data?.isJoin) {
                    window.open(`${res?.data?.route}/admin/login?query=${encodeURIComponent(JSON.stringify({...res.data, email: signUpData?.workEmail}))}`, '_blank');
                    setSignUpData({
                        company: '',
                        workEmail: '',
                        signPassword: '',
                        signCnfmPassword: ''
                    });
                    setLoginDataErrors((prev) => {
                        return {
                            ...prev,
                            workEmail: { errorMessage: '', showError: false },
                            signPassword: { errorMessage: '', showError: false },
                            signCnfmPassword: { errorMessage: '', showError: false }
                        }
                    });
                } else if (res && res?.data?.isExists && !res?.data?.isJoin) {
                    window.open(`${res?.data?.route}/admin/login`, '_blank');
                } else if (res && (res?.data?.route == 'onboard' || res?.data?.returnRoute == 'onboard') && res?.data?.isValid) {
                    const payload = {
                        isValid: true,
                        email: signUpData?.workEmail,
                    };

                    const encodedQuery = encodeData(payload);
                    navigate(`/onboarding?query=${encodedQuery}`);

                    // navigate(`/onboarding?query=${encodeURIComponent(JSON.stringify({isValid: true, email: signUpData?.workEmail}))}`);
                } else {
                    const payload = {
                        isValid: true,
                        email: signUpData?.workEmail,
                    };

                    const encodedQuery = encodeData(payload);
                    // navigate(`/verify-email?query=${encodeURIComponent(JSON.stringify({isValid: true, email: signUpData?.workEmail}))}`);
                    navigate(`/verify-email?query=${encodedQuery}`);
                }
            }

        } catch (error) {
            console.error('Error:', error);
            setIsSignUpLoading(false);
        }
    }

    const togglePasswordVisibility = () => {
        setIsVisiblePassword(!isVisiblePassword);
    };

    const toggleCnfrmPasswordVisibility = () => {
        setIsVisibleCnfrmPassword(!isVisibleCnfrmPassword);
    };

    const toggleLoginPasswordVisibility = () => {
        setIsVisibleLoginPassword(!isVisibleLoginPassword);
    }

    const handleAdminLogin = async () => {
        try {
            if (!loginData.email) {
                setLoginDataErrors((prevState) => ({
                    ...prevState,
                    email: { errorMessage: 'Email is required', showError: true }
                }));
                return;
            }
            if (!loginData.password) {
                setLoginDataErrors((prevState) => ({
                    ...prevState,
                    password: { errorMessage: 'Password is required', showError: true }
                }));
                return;
            }
            if (!loginDataErrors.email.showError && !loginDataErrors.password.showError) {
                setIsLoginLoading(true);
                let payload = {
                    email: loginData.email,
                    password: loginData.password
                }
                const res = await api.post("/auth/login", payload)
                setIsLoginLoading(false);
                if (res) {
                    setLoginData({
                        email: '',
                        password: ''
                    });
                    setLoginDataErrors((prev) => {
                        return {
                            ...prev,
                            email: { errorMessage: '', showError: false },
                            password: { errorMessage: '', showError: false }
                        }
                    });
                    window.open(`${process.env.CRM_API_URL}/admin/dashboard`, "_self");
                }
            }
        } catch (error) {
            console.error('Error:', error.message);
            setIsLoginLoading(false);
        }
    }

    const handleMicrosoftLogin = async () => {
        try {
            window.location.href = `${process.env.REACT_APP_CRM_API_URL}/auth/microsoft?method=${isSignUp ? 'signupwithmicrosoft' : 'loginwithmicrosoft'}`;
            // await api.get(`/auth/microsoft?method=${isSignUp ? 'signupwithmicrosoft' : 'loginwithmicrosoft'}`);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const handleGoogleLogin = () => {
         try {
            window.location.href = `${process.env.REACT_APP_CRM_API_URL}/auth/google?method=${isSignUp ? 'signupwithgoogle' : 'loginwithgoogle'}`;
        } catch (error) {
            console.error('Error:', error);
        }
    }

    useEffect(() => {
        if (passwordRef.current) {
            passwordRef.current.getInput().type = isVisiblePassword ? "text" : "password";
        }
    }, [isVisiblePassword]);


    return (
        <div className='flex flex-col justify-center items-center h-screen'>
            <div>
                <img src="/images/crileo-logo.png" alt="logo" className='object-cover w-[150px] h-[80px]' />
            </div>
            <div className={`p-5 ${styles.loginContainer}`}>
                <div className={`flex flex-col justify-center items-center mb-3`}>
                    <h3 className="text-[18px]">Welcome</h3>
                    <h5 className='text-stone-500 text-[14px]'>Sign in to your account or create a new one</h5>
                </div>

                <div
                    className={`flex items-center justify-center gap-2 row p-0 m-0 ${styles.microsoftLogo}`}
                    onClick={() => handleMicrosoftLogin()}
                >
                    <div className="col-2">
                        <img
                            src="/images/microsoft-logo.png"
                            alt="Microsoft Logo"
                        />
                    </div>
                    <span className="col-8 font-semibold fs-5">Signup with Microsoft</span>
                </div>
                {/* <div
                    className={`flex items-center justify-center mt-3 gap-2 row p-0 m-0 ${styles.googleLogo}`}
                    onClick={() => handleGoogleLogin()}
                >
                    <div className="col-2">
                        <img
                            src="/images/google-logo.png"
                            alt="Google Logo"
                        />
                    </div>
                    <span className="col-8 font-semibold fs-5">Signup with Google</span>
                </div> */}
                <div className={`flex items-center my-4`}>
                    <hr className="w-[45%]" />
                    <span className='flex justify-center mx-3 fs-5'>or</span>
                    <hr className="w-[45%]" />
                </div>

                {/* Toggle Tabs */}
                <div className={`${styles.loginPageTabs} flex justify-around`}>
                    <form className="w-[100%]">
                        {/* <div className="flex flex-col my-3 relative">
                                    <label className='font-semibold mb-1'>Company Name</label>
                                    <div
                                        className={`absolute left-[10px] ${loginDataErrors?.company.showError ? 'top-[44%]' : 'top-[59%]'}`}
                                    >
                                        <IconUser size={16} />
                                    </div>
                                    <input
                                        type="text"
                                        className={`border rounded-[8px] h-[36px] ps-[2rem] bg-[#f3f3f5] outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)] ${loginDataErrors?.company.showError ? 'border-red-500' : 'border-[#a1a1a1]'}`}
                                        placeholder="Company Name"
                                        value={signUpData?.company}
                                        onChange={(e) => updateSignUpData('company', e.target.value)}
                                    />
                                </div> */}
                        <div className="flex flex-col mb-3 relative">
                            <label className='font-semibold mb-1'>Work Email</label>
                            <div
                                className={`absolute left-[10px] ${loginDataErrors?.workEmail.showError ? 'top-[44%]' : 'top-[59%]'}`}
                            >
                                <IconMail size={16} />
                            </div>
                            <input
                                type="email"
                                className={`border rounded-[8px] h-[36px] ps-[2rem] bg-[#f3f3f5] outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)] ${loginDataErrors?.workEmail.showError ? 'border-red-500' : 'border-[#a1a1a1]'}`}
                                placeholder="Your Work Email"
                                value={signUpData?.workEmail}
                                onChange={(e) => updateSignUpData('workEmail', e.target.value)}
                            />
                            {loginDataErrors?.workEmail.showError && <span className='text-red-500'>{loginDataErrors?.workEmail.errorMessage}</span>}
                        </div>
                        <div className={`relative my-3 flex flex-col`}>
                            <label className='font-semibold mb-1'>Password</label>
                            <div
                                className={`z-10 absolute ${loginDataErrors?.signPassword.showError ? 'top-[44%]' : 'top-[58%]'} left-[10px]`}
                            >
                                <IconLock size={16} />
                            </div>
                            <Password
                                onFocus={() => setIsVisiblePassword(false)}
                                ref={passwordRef}
                                placeholder='Password'
                                name='signPassword'
                                value={signUpData?.signPassword}
                                onChange={(e) => updateSignUpData('signPassword', e.target.value)}
                                header={header}
                                footer={footer}
                                className={`${styles.passwordInput} border-[#a1a1a1] w-full border rounded-[8px] h-[36px] ps-[2rem] bg-[#f3f3f5] outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)]`}
                                strongRegex={/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/}
                                type={isVisiblePassword ? 'text' : 'password'}
                            />
                            <div
                                className={`absolute cursor-pointer ${loginDataErrors?.signPassword.showError ? 'top-[44%]' : 'top-[58%]'} right-[10px]`}
                                onClick={() => togglePasswordVisibility()}
                            >
                                {isVisiblePassword ? <IconEyeOff size={17} /> : <IconEye size={17} />}
                            </div>
                            {loginDataErrors?.signPassword.showError && <span className='text-red-500'>{loginDataErrors?.signPassword.errorMessage}</span>}
                        </div>
                        <div className="my-3 relative flex flex-col">
                            <label className='font-semibold mb-1'>Confirm Password</label>
                            <div
                                className={`z-10 absolute ${loginDataErrors?.signCnfmPassword.showError ? 'top-[44%]' : 'top-[58%]'} left-[10px]`}
                            >
                                <IconLock size={16} />
                            </div>
                            <input
                                type={isVisibleCnfrmPassword ? 'text' : 'password'}
                                className={`border rounded-[8px] h-[36px] ps-[2rem] bg-[#f3f3f5] outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)] ${loginDataErrors?.password.showError ? 'border-red-500' : 'border-[#a1a1a1]'}`}
                                placeholder="Confirm Password"
                                value={signUpData?.signCnfmPassword}
                                onChange={(e) => updateSignUpData('signCnfmPassword', e.target.value)}
                            />
                            <div
                                className={`absolute cursor-pointer ${loginDataErrors?.signCnfmPassword.showError ? 'top-[44%]' : 'top-[58%]'} right-[10px]`}
                                onClick={() => toggleCnfrmPasswordVisibility()}
                            >
                                {isVisibleCnfrmPassword ? <IconEyeOff size={17} /> : <IconEye size={17} />}
                            </div>
                            {loginDataErrors?.signCnfmPassword.showError && <span className='text-red-500'>{loginDataErrors?.signCnfmPassword.errorMessage}</span>}
                        </div>
                        <button
                            type="button"
                            className="btn w-full h-[36px] bg-[#101828] disabled:bg-[#5f5e5e] text-white rounded-[8px] flex items-center justify-center gap-2 mt-[2rem]"
                            onClick={() => handleCreateWorkspace()}
                            disabled={isSignUpLoading}
                        >
                            {isSignUpLoading &&
                                <div role="status">
                                    <svg aria-hidden="true" class="inline w-8 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                    <span class="sr-only">Loading...</span>
                                </div>
                            }
                            Create Workspace
                        </button>
                    </form>
                    {/* <TabView
                        activeIndex={!isSignUp ? 0 : 1}
                        onTabChange={(e) => setIsSignUp(e.index === 1)}
                    >
                        <TabPanel header="Log In">
                            <form>
                                <div className="flex flex-col my-3 relative">
                                    <label className='font-semibold mb-1'>Email</label>
                                    <div
                                        className={`absolute left-[10px] ${loginDataErrors?.email.showError ? 'top-[44%]' : 'top-[59%]'}`}
                                    >
                                        <IconMail size={16} />
                                    </div>
                                    <input
                                        type="email"
                                        name='email'
                                        className={`border rounded-[8px] h-[36px] ps-[2rem] bg-[#f3f3f5] outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)] ${loginDataErrors?.email.showError ? 'border-red-500' : 'border-[#a1a1a1]'}`}
                                        placeholder="Your Work Email"
                                        onChange={(e) => updateLoginData(e)}
                                    />
                                    {loginDataErrors?.email.showError && <span className='text-red-500'>{loginDataErrors?.email.errorMessage}</span>}
                                </div>
                                <div className="flex flex-col mb-4 relative">
                                    <label className='font-semibold mb-1'>Password</label>
                                    <div
                                        className={`absolute ${loginDataErrors?.password.showError ? 'top-[44%]' : 'top-[59%]'} left-[10px]`}
                                    >
                                        <IconLock size={16} />
                                    </div>
                                    <input
                                        type={isVisibleLoginPassword ? 'text' : 'password'}
                                        name='password'
                                        className={`border rounded-[8px] h-[36px] ps-[2rem] bg-[#f3f3f5] outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)] ${loginDataErrors?.password.showError ? 'border-red-500' : 'border-[#a1a1a1]'}`}
                                        placeholder="Password"
                                        onChange={(e) => updateLoginData(e)}
                                    />
                                    {loginDataErrors?.password.showError && <span className='text-red-500'>{loginDataErrors?.password.errorMessage}</span>}
                                    <div
                                        className={`absolute cursor-pointer translate-y-[-50%] ${loginDataErrors?.password.showError ? 'top-[52%]' : 'top-[70%]'} right-[10px]`}
                                        onClick={() => toggleLoginPasswordVisibility()}
                                    >
                                        {isVisibleLoginPassword ? <IconEyeOff size={17} /> : <IconEye size={17} />}
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn w-full h-[36px] bg-[#101828] text-white rounded-[8px] flex items-center justify-center gap-2 mt-[2rem]"
                                    onClick={() => handleAdminLogin()}
                                    disabled={isLoginLoading}
                                >
                                    {isLoginLoading &&
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    }
                                    Log In
                                </button>
                            </form>
                        </TabPanel>
                        <TabPanel header="Sign Up">
                        </TabPanel>
                    </TabView> */}
                </div>
            </div>
            <div className='mt-5'>
                <span className='text-[#717182] fs-5'>By continuing, you agree to our <a className='text-[#717182] underline' href='https://crileo.com/terms-of-service/' target='_blank'>Terms of Service</a> and <a className='text-[#717182] underline' href='https://crileo.com/privacy-policy/' target='_blank'>Privacy Policy</a></span>
            </div>
        </div>
    );
}
